export default "__VITE_ASSET__101fcbe3__"